import * as form from '../form';

export const substanceDrugMisuse = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        PrescriptionName: form.text(xitem.PrescriptionName),
        InvolvementDates: form.daterange(xitem.InvolvementDates),
        Reason: form.textarea(xitem.Reason),
        UseWhileEmployed: form.branch(xitem.UseWhileEmployed),
        UseWithClearance: form.branch(xitem.UseWithClearance),
        Comments: form.textarea(xitem.Comments),
        HowManyTimes: form.text(xitem.HowManyTimes), // PVQOnly
        UseWhileEmployedPosition: form.text(xitem.UseWhileEmployedPosition), // PVQOnly
        UseWhileEmployedExplanation: form.textarea(xitem.UseWhileEmployedExplanation), // PVQOnly
        UseWithClearanceExplanation: form.textarea(xitem.UseWithClearanceExplanation), // PVQOnly
        UseInFuture: form.branch(xitem.UseInFuture), // PVQOnly
        UseInFutureExplanation: form.textarea(xitem.UseInFutureExplanation), // PVQOnly
      },
    };
  });
  return {
    MisusedDrugs: form.branch(data.MisusedDrugs),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
